import { SproutCommonContent } from "../../../../modules/content/components/SproutCommonContent/SproutCommonContent";
import { SproutMedia } from "../../../../modules/content/components/SproutMedia/SproutMedia";
import { SproutSection } from "../../../../modules/content/components/SproutSection/SproutSection";
import type { IImageBlockProps } from "./ImageBlock.props";

export const ImageBlock = ({
  alignment,
  anchorId,
  buttons,
  description,
  eyebrow,
  heading,
  image,
  parentClass,
  spacing,
}: IImageBlockProps) => {
  if (!image) return null;

  return (
    <SproutSection className={parentClass} id={anchorId} spacing={spacing}>
      <div className="flex flex-col gap-8 md:gap-12">
        <SproutCommonContent
          alignment={alignment}
          buttons={buttons}
          description={description}
          eyebrow={eyebrow}
          heading={heading}
        />
        <SproutMedia
          aspectRatio={image.aspectRatio}
          className="sprout-chapter-tab sprout-paper-lift overflow-visible rounded-[1.5rem_1.5rem_1.5rem_0.35rem] border-[0.65rem] border-whiteboard"
          imageClassName="rounded-xl"
          media={image.image}
          sizes="(min-width: 1280px) 1184px, calc(100vw - 48px)"
        />
      </div>
    </SproutSection>
  );
};

ImageBlock.displayName = "Block::ImageBlock";
